<script>
    import Authentication from '../services/authentication.js'
    import router from "page";
    import ToastComponent from '../components/ToastComponent.svelte'
    import { notifications } from '../services/notification'

    let username = null
    let password = null

    export let params

    const login = async () => {

        try {
            
            let result = await Authentication.login(username, password)
            
            console.log(result)

            if(result.success) {
                if(params.hasOwnProperty('redirect')) {
                    router(params.redirect)
                } else {
                    router("/")
                }
            }
            if(!result.success) notifications.danger(result.data.message)

        } catch(e) {
            console.log('E', e)
            notifications.danger(e.data.message)
        }

    }
    
</script>

<h2 class="mb-6 text-center text-white mt-5 mb-5">Se connecter</h2>


<div class="row justify-content-center mt-3 mb-3">

    <div class="col-md-6 my-card">

        <div class="text-center mt-4">
            <input type="text" bind:value={username} class="p-2" placeholder="Entrez un pseudo"/>
        </div>

        <div class="text-center mt-4">
            <input type="password" bind:value={password} class="p-2" placeholder="Entrez un mot de passe"/>
        </div>
        <div class="text-center mt-4">
            <button type="button" on:click={login} class="btn btn-light">Se connecter</button>
        </div>

    </div>



</div>
<ToastComponent></ToastComponent>

<style>
    .my-card {
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
        border-radius: 10px;
        padding: 15px 5px;
        color: #000;
        background-color: #ffffffa1;
    }
</style>





